module.exports = __webpack_public_path__ + "static/media/rank-c.6ec44656.png";